import { SettingsQuery } from '@state/settings/settings.query';
import {ClinicQuery} from '@state/clinic/clinic.query';
import {ClinicService} from '@state/clinic/clinic.service';
import {SettingsService} from '@state/settings/settings.service';
import {Injectable} from '@angular/core';
import {Observable, of} from 'rxjs';
import {finalize, shareReplay, switchMap} from 'rxjs/operators';

@Injectable({ providedIn: 'root' })
export class InitFlowwwService {
    private initInFlight$: Observable<void> | null = null;

    constructor(
        private clinicQuery: ClinicQuery,
        private clinicService: ClinicService,
        private settingsQuery: SettingsQuery,
        private settingsService: SettingsService
    ) {}

    get initInProgress(): boolean {
        return this.initInFlight$ !== null;
    }

    init(): Observable<void> {
        // settingsLoaded es la única fuente de verdad: systemLogout lo resetea,
        // así que tras un re-login la inicialización vuelve a ejecutarse.
        // No basta por sí solo: se commitea ANTES de initClinic, así que si
        // initClinic falló la clínica activa queda a medias (sin cabinets ni
        // horarios, loaded !== true) y el grid de la agenda no podría cargar
        // nunca — en ese caso hay que reintentar
        if (this.settingsQuery.settingsLoaded && this.clinicQuery.getActive()?.loaded) {
            return of(void 0);
        }

        // Compartir la petición en vuelo: app.component y las páginas (vía
        // InitFlowwwPromiseService) pueden pedir la inicialización a la vez y
        // solo debe lanzarse un SEC_FLOWWWME_INIT_FORM
        if (!this.initInFlight$) {
            // Con settings ya cargados solo falta la clínica: reintentar
            // únicamente initClinic evita repetir el init completo y sus
            // efectos (alta de clínicas, toasts, labels)
            const init$ = this.settingsQuery.settingsLoaded && this.clinicQuery.getActive()
                ? this.clinicService.initClinic()
                : this.settingsService.initFlowwwMe().pipe(
                    switchMap(() => this.clinicService.initClinic())
                );

            this.initInFlight$ = init$.pipe(
                finalize(() => this.initInFlight$ = null),
                shareReplay({ bufferSize: 1, refCount: false })
            );
        }

        return this.initInFlight$;
    }
}
